const _temp0 = require("./imgs/amax_client_files.png");
const _temp1 = require("./imgs/amax_emu_files.png");
const _temp2 = require("./imgs/blur_update_files.png");
const _temp3 = require("./imgs/files_guide2.png");
module.exports = {
  "amax_client_files": _temp0,
  "amax_emu_files": _temp1,
  "blur_update_files": _temp2,
  "files_guide2": _temp3
}